export const DEFAULT_ONLINE_CART_RECORD_ID = '363f170489001ec2b72d57dc62b66ea4374197c29e9523c73b90cb2ad78c7dc6';
export const ONLINE_CART_ANSWER_ID_QUERY_PARAM = 'answerId';
export const ONLINE_CART_ANSWER_STORAGE_PREFIX = 'online-cart-answer-id:';

export function getOnlineCartAnswerStorageKey(recordId = '') {
    return `${ONLINE_CART_ANSWER_STORAGE_PREFIX}${recordId}`;
}

export function getPersistedOnlineCartAnswerId(recordId = '', searchParams = null) {
    const answerIdFromQuery = typeof searchParams?.get === 'function' ? String(searchParams.get(ONLINE_CART_ANSWER_ID_QUERY_PARAM) || '').trim() : '';
    return answerIdFromQuery;
}
